/*
 * Copyright (C) 2023 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { CommandOrder, CommandResource } from '@alfa-client/command-shared';
import { HistorieItemHeaderComponent } from '@alfa-client/historie-shared-ui';
import { Component, input } from '@angular/core';

@Component({
  selector: 'alfa-historie-item-vorgang-status',
  templateUrl: './historie-item-vorgang-status.component.html',
  styleUrls: ['./historie-item-vorgang-status.component.scss'],
  imports: [HistorieItemHeaderComponent],
})
export class HistorieItemVorgangStatusComponent {
  readonly command = input.required<CommandResource>();

  get headline(): string {
    return HISTORIE_TEXT_BY_VORGANG_STATUS_ORDER[this.command().order];
  }
}

const HISTORIE_TEXT_BY_VORGANG_STATUS_ORDER: { [order: string]: string } = {
  [CommandOrder.VORGANG_ANNEHMEN]: 'den Vorgang in den Status Angenommen versetzt.',
  [CommandOrder.VORGANG_VERWERFEN]: 'den Vorgang in den Status Verworfen versetzt.',
  [CommandOrder.VORGANG_ZURUECKHOLEN]: 'den Vorgang in den Status Neu versetzt.',
  [CommandOrder.VORGANG_BEARBEITEN]: 'den Vorgang in den Status In Bearbeitung versetzt.',
  [CommandOrder.VORGANG_BESCHEIDEN]: 'den Vorgang in den Status Beschieden versetzt.',
  [CommandOrder.VORGANG_ZURUECKSTELLEN]: 'den Vorgang in den Status Angenommen versetzt.',
  [CommandOrder.VORGANG_ABSCHLIESSEN]: 'den Vorgang in den Status Abgeschlossen versetzt.',
  [CommandOrder.VORGANG_WIEDEREROEFFNEN]: 'den Vorgang in den Status In Bearbeitung versetzt.',
  [CommandOrder.VORGANG_ZUM_LOESCHEN_MARKIEREN]: 'eine Löschanforderung gestellt.',
};
